import React, { useEffect, useState } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal, { COLOR_ZONA_DEFAULT } from "./AddUpdModal";
import { resourcesZones } from "../../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../../helpers/alerts/alertHelper";
import { getStorageUser } from "../../../helpers/api_helper";
import { Container } from "reactstrap";
import ButtonHelper from "../../../helpers/ButtonHelper";

const Zonas = () => {
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    companySession: authUser.company_id,
  });
  const [items, setItems] = useState([]);

  const [itemBase, setItemBase] = useState({
    id: null,
    name: "",
    // Explicito: el selector de color muestra este valor desde el inicio, asi
    // que tiene que existir en Formik o se guarda sin color.
    color: COLOR_ZONA_DEFAULT,
    route_id: authUser.route_id,
  });

  const [item, setItem] = useState(itemBase);

  useEffect(() => {
    const getZones = async () => {
      let params = { params: filters };
      setPending(true);
      const response = await resourcesZones("get", params);
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    };
    getZones();
  }, [filters]);

  const addUpd = (row = false) => {
    setItem(row.id ? row : itemBase);
    setModal({ ...modal, show: true, update: row.id ? true : false });
  };

  const destroy = async (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      const response = await resourcesZones("del", id, id);
      Alert(response.message, response.status);
      if (response.status) {
        setItems(items.filter((i) => i.id != id));
      }
    });
  };

  const columns = Columns(addUpd, destroy);
  document.title = "Zonas | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Zonas"
              filterInp={true}
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              {/* Optional chaining: una sesion abierta desde antes del despliegue
                  no tiene la clave `zonas` en `can` y la pagina reventaria. */}
              {authUser.can?.zonas?.create && (
                <div className="col align-self-end">
                  <ButtonHelper addButon={true} actionAddButon={addUpd} />
                </div>
              )}
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={item}
            setItem={setItem}
            authUser={authUser}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Zonas;
